import { Base } from '@studiometa/js-toolkit';
import ProductStickyAddToCart from './ProductStickyAddToCart.js';
import Gallery from './Gallery.js';
import ZoomedGallery from './ZoomedGallery/index.js';
import ProductInfo from './ProductInfo/index.js';

/**
 * Product Component
 *
 */
export default class Product extends Base {
  static config = {
    name: 'Product',
    components: {
      ProductInfo,
      Gallery,
      ZoomedGallery,
      ProductStickyAddToCart,
    },
  };
}
